// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ExpandButton {\n  transition: transform 100ms ease-in-out;\n}\n  .ExpandButton:not(.expanded) {\n    transform: rotate(-90deg);\n  }\n  .ExpandButton img {\n    width: 8px;\n    height: 8px;\n  }", ""]);
// Exports
module.exports = exports;
